import { Box, Stack, Typography } from "@mui/material";
import { FileViewLoader } from "components/FileView";
import { Document } from "types";

export type FilePreviewProps = {
    document?: Document;
    previewToggleControl?: JSX.Element;
    onClick: () => void;
}

// TODO rename with DocumentPreview
export function FilePreview({ document, onClick, previewToggleControl }: FilePreviewProps) {

    if (document)
        return <FileViewLoader
            fileView="preview"
            document={document}
            onClick={onClick}
            fallbackMessage
            cursor={"zoom-in"}
            additionalControls={[
                {
                    control: previewToggleControl,
                    position: "start"
                }
            ]}
        />

    return <>
        <Box position="absolute" top="0" left="0" sx={{ padding: 0.5, paddingLeft: 1, paddingTop: "5px" }}>{previewToggleControl}</Box>
        <Stack alignItems="center" justifyContent="center" height="100%">
            <Typography>Select a file to preview.</Typography>
        </Stack>
    </>
}